export enum AptCustomerType {
    Microbusiness = 'Microbusiness',
    Residenziale = 'Residenziale',
}
